import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import TeamPage from './pages/TeamPage';
import ChatPage from './pages/ChatPage';
import BlogsPage from './pages/BlogsPage';
import VideosPage from './pages/VideosPage';
import DashboardPage from './pages/DashboardPage';
import HealthDashboardPage from './pages/HealthDashboardPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AnnaliseChat from './components/AnnaliseChat';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/chat/:doctorName" element={<ChatPage />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/health" element={<HealthDashboardPage />} />
          </Routes>
          <AnnaliseChat />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
